import React, { memo } from "react";
import { Route, Routes } from "react-router-dom";
import { routesName } from "core";
import { UsersList } from "components/src";
import { CallsReport } from "./callsReport";
import { MessagesReport } from "./messagesReport";

const Reports = memo(() => {
  return (
    <Routes>
      <Route path={routesName.CALLSREPORT} element={<CallsReport />} />
      <Route path={routesName.MESSAGESREPORT} element={<MessagesReport />} />
    </Routes>
  );
});

export { Reports };
